<script setup lang="ts">
const {
  searchKeyword,
  typeFacetOptions,
  legalAreaFacetOptions,
  authorFacetOptions,
  typeSelected,
  legalAreaSelected,
  authorSelected,
  toggleType,
  toggleLegalArea,
  toggleAuthor,
  searchLegalArea,
  searchAuthor,
  isLoading,
} = useLiteratureFilters()
</script>

<template>
  <aside aria-label="Filtervalg" class="flex flex-col gap-m w-[369px] pt-l">
    <div class="flex flex-col gap-s">
      <label for="literature-title-author-filter" class="title-s font-bold">
        Filtrer på tittel, forfatter eller rettsområde
      </label>
      <FormSearchInput
        id="literature-title-author-filter"
        v-model="searchKeyword"
        external-label
        resettable
        shape="square"
        size="medium"
      />
    </div>

    <FilterSkeleton v-if="isLoading" />

    <div class="flex flex-col gap-s">
      <span class="text-small font-bold">Type litteratur</span>
      <FilterFacetList
        class="gap-s"
        label="Type litteratur"
        name="literatureType"
        expand-noun="litteraturtyper"
        :searchable="false"
        :options="typeFacetOptions"
        :selected="typeSelected"
        :toggle="toggleType"
      />
    </div>

    <div v-if="legalAreaFacetOptions.length" class="flex flex-col gap-s">
      <span class="text-small font-bold">Rettsområde</span>
      <FilterFacetList
        v-model:search="searchLegalArea"
        class="gap-s"
        label="Rettsområde"
        name="literatureLegalArea"
        expand-noun="rettsområder"
        :options="legalAreaFacetOptions"
        :selected="legalAreaSelected"
        :toggle="toggleLegalArea"
      />
    </div>

    <div v-if="authorFacetOptions.length" class="flex flex-col gap-s">
      <span class="text-small font-bold">Forfattere</span>
      <FilterFacetList
        v-model:search="searchAuthor"
        class="gap-s"
        label="Forfattere"
        name="literatureAuthor"
        expand-noun="forfattere"
        :options="authorFacetOptions"
        :selected="authorSelected"
        :toggle="toggleAuthor"
      />
    </div>
  </aside>
</template>